import useStore from "../store.ts";
import { getParent } from "./ElementUtils.ts";

/* see docs/EXTRACTED_COMMENTS.md#c163 */
export function dependsOnChildren(autoSize: string | undefined | null): boolean {
    return !!autoSize && autoSize.includes("CHILD");
}

/* see docs/EXTRACTED_COMMENTS.md#c164 */
export function collectAutoSizeAncestors(id: string): string[] {
    const store = useStore();
    const ancestors: string[] = [];
    let currentId = getParent(id);

    while (currentId) {
        const comp = store.components[currentId];
        if (!comp) break;

        if (dependsOnChildren(comp.auto_size)) {
            ancestors.push(currentId);
        }

        currentId = getParent(currentId);
    }

    return ancestors;
}

/**
 * Collect auto-size ancestors for multiple ids (deduped).
 */
export function collectAutoSizeAncestorsForMany(ids: Iterable<string>): string[] {
    const seen = new Set<string>();
    const result: string[] = [];

    for (const id of ids) {
        for (const ancestorId of collectAutoSizeAncestors(id)) {
            if (seen.has(ancestorId)) continue;
            seen.add(ancestorId);
            result.push(ancestorId);
        }
    }

    return result;
}

export function markForUpdate(_ids: Iterable<string>): void {
    // see docs/EXTRACTED_COMMENTS.md#c165
}


